import * as React from 'react';
import { useState } from 'react';
import './AvailabilityReportForm.scss';
import { Select } from 'Src/components/Select/Select';
import { getSelectOptionsForChildren } from 'Src/helpers/table/select';
import { Child } from 'Src/models/child';
import { Report } from 'Src/models/report';
import '../../components/ParentDesign.scss';

interface Props {
  onCancel: () => void;
  onSubmit: (data) => void;
  childrenInEvent: Child[];
  initialReport?: Report;
}

export function AvailabilityReportForm(props: Props) {
  const { childrenInEvent, initialReport } = props;

  const isSeveralChildrenInEvent = childrenInEvent.length > 1;
  const selectOptionsForChildren = getSelectOptionsForChildren(childrenInEvent);

  const initialChildIndex = initialReport
    ? Math.max(0, childrenInEvent.findIndex(child => String(child.id) === String(initialReport.playerDetails?.userId)))
    : 0;
  const [details, setDetails] = useState(initialReport?.details || '');
  const [selectedChildIndex, setSelectedChildIndex] = useState(initialChildIndex);
  const [isTakePart, setIsTakePart] = useState<boolean | undefined>(
    typeof initialReport?.isTakePart === 'boolean' ? initialReport.isTakePart : undefined
  );
  const [showChoiceError, setShowChoiceError] = useState(false);

  const selectedChild = childrenInEvent[selectedChildIndex];

  const submitForm = () => {
    if (typeof isTakePart !== 'boolean') {
      setShowChoiceError(true);
      return;
    }
    const data = {
      details,
      isTakePart,
      playerDetails: {
        permissionId: selectedChild.permissionId,
        userId: selectedChild.id
      }
    };
    props.onSubmit(data);
  };

  const onDetailsChange = event => {
    setDetails(event.target.value);
  };

  return (
    <div className="bAvailabilityReport">
      <div className="eAvailabilityReportTitle">Can {selectedChild?.firstName || 'this child'} take part?</div>
      <p className="eAvailabilityReportSubtitle">Choose an answer and add an optional note for the school.</p>

        {isSeveralChildrenInEvent && !initialReport && (
          <div className="eAvailabilityReportField">
            <div className="eAvailabilityReportLabel">Select child</div>
            <div>
              <Select
                onChange={value => {
                  const options = selectOptionsForChildren;
                  const nextIndex = options.findIndex(option => option.value === value);
                  setSelectedChildIndex(nextIndex);
                }}
                options={selectOptionsForChildren}
                activeResultIndex={selectedChildIndex}
                customClass={'form-control'}
              />
            </div>
          </div>
        )}

        <div className="eAvailabilityReportField">
          <div className="eAvailabilityReportChips">
            <button type="button" className={isTakePart === true ? 'is-selected is-available' : ''} onClick={() => { setIsTakePart(true); setShowChoiceError(false); }}><span>✓</span><b>Available</b></button>
            <button type="button" className={isTakePart === false ? 'is-selected is-unavailable' : ''} onClick={() => { setIsTakePart(false); setShowChoiceError(false); }}><span>×</span><b>Not available</b></button>
          </div>
          {showChoiceError ? <div className="eAvailabilityReportChoiceError" role="alert">Choose one option</div> : null}
        </div>

        <div className="eAvailabilityReportField">
          <div className="eAvailabilityReportLabel">Note for the school <span>Optional</span></div>
          <textarea
            className="eAvailabilityReportInput"
            value={details}
            placeholder={isTakePart === false ? 'For example: dentist appointment that morning' : 'For example: I’ll collect from the venue'}
            onChange={event => onDetailsChange(event)}
          />
        </div>

        <div className="eAvailabilityReportActions">
          <button type="button" className="parentButton" onClick={props.onCancel}>
            Cancel
          </button>
          <button type="button" className="parentButton parentButton--primary" onClick={submitForm}>
            {initialReport ? 'Save changes' : 'Send to school'}
          </button>
        </div>
    </div>
  );
}
